import { CoreMenuCategoryPage } from 'dispensary/core-menu/category';
import { CoreMenuLayout } from 'components/layouts/core-menu-layout';
import { withLayout } from 'src/components/layouts/with-layout';

export default withLayout(CoreMenuCategoryPage, CoreMenuLayout);
